$(function() {

    Handlebars.registerHelper('nl2br', function(object) {
        return new Handlebars.SafeString(
            (object + '').replace(/([^>\r\n]?)(\r\n|\n\r|\r|\n)/g, '$1<br/>$2')
        );
    });

    // Models
    var search   = new Search();
    var cart     = new Cart();
    var vehicle  = new Vehicle();
    var stock    = new Stock();

    // Cached elements
    var $search          = $('#search');
    var $cart            = $('#cart');
    var $completed_items = $('#completed-items');
    var $notes_modal     = $('#notes-modal');
    var $stock_info_modal = $('#stock-info-modal');
    var $full_details_modal = $('#full-details-modal');
    var $vehicles = $('.vehicle');
    var $add_confirmation_modal = $('#add-confirmation-modal');
    var $categories_container = $('#categories-container');

    // Filters
    var $quality_filter = $('#filter-quality');
    var $year_filter = $('#filter-year');

    // Templates
    var makes_template         = Handlebars.compile($("#makes-template").html());
    var models_template        = Handlebars.compile($("#models-template").html());
    var part_types_template    = Handlebars.compile($("#part-types-template").html());
    var applications_templates = Handlebars.compile($("#applications-template").html());
    var stocks_template        = Handlebars.compile($("#stocks-template").html());
    var stocks_template_aft    = Handlebars.compile($("#stocks-template-aftermarket").html());

    var infos_messages = new Messages('#infos-messages');
    var window_messages = new Messages('#messages');

    // Get a message handler for the element
    var get_messages = function(elem)
    {
        var messages = elem.data('messages');

        if(messages === undefined)
        {
            messages = new Messages($('<div></div>').insertAfter(elem));
            elem.data('messages', messages);
        }

        return messages;
    };

    // Method to manage the default show and hide of additional information
    var standard_display = function(expand, handle_data)
    {
        handle_data || (handle_data = function(content) { expand.find('.selection').html(content); });

        return {
            success: function(content)
            {
                handle_data(content);

                $('#search .expand').not(expand).hide('fast');
                expand.show('fast');
            },
            error: function(message)
            {
                get_messages(expand).error(message, 2000);
                expand.hide('fast');
            }
        }
    };

    if($(".vehicle").length == 0)
    {
        $('.vehicle-add').show();
    }
    else
    {
        $('.vehicle-add').hide();
    }

    $stock_info_modal.on("show.bs.modal", function(e) {
        var stock_id = $(e.relatedTarget).data('stock_id');

        if (stock_id) {
            $(this).find(".modal-body").load(document.base_url+'stock/info_modal/'+stock_id);
        }
    });

    $stock_info_modal.on('click', '.stock-info-picture', function(e) {
        e.preventDefault();

        var pictures = document.querySelectorAll('.stock-info-picture');

        var items = [];

        for (var i = 0; i < pictures.length; i++) {
            var picture = pictures[i];
            items.push({
                src: picture.getAttribute('src'),
                w: picture.naturalWidth,
                h: picture.naturalHeight
            });
        }

        var options = {
            index: $(this).data('index')
        };

        var lightBox = new PhotoSwipe(document.querySelector('#photos-modal'), PhotoSwipeUI_Default, items, options);
        lightBox.init();
    });

    // Updates the makes for the selected year
    $('#year').bind('change', function(){
        var year = $(this).val();

        search.makes(year, {
            messages: get_messages($(this)),
            success: function(data)
            {
                $('#make')
                    .html(makes_template({makes: data}))
                    .trigger("liszt:updated");

                $('#make').trigger('change');
            }
        });
    });

    // Updates the models for the selected make
    $('#make').bind('change', function(){
        var year    = $('#year').val();
        var make_id = $(this).val();

        search.models(year, make_id, {
            messages: get_messages($(this)),
            success: function(data)
            {
                $('#model')
                    .html(models_template({models: data}))
                    .trigger("liszt:updated")
                    .trigger('change');
            }
        });
    });

    $(document).on('click', '.full-details', function(e) {
        e.preventDefault();

        var application_name = $(this).data('application_name');
        application_name = application_name.replace(new RegExp("\\|", "g"), ", ");
        $full_details_modal.find(".modal-body").html(application_name);
    });

    // Showing the part-types
    $search.on('select2:open', '.part-types', function()
    {
        var parent   = $(this).closest('.vehicle');
        var model_id = parent.data('model_id');
        var year     = parent.data('year');

        if(!this.partTypesLoaded)
        {
            this.loading = true;
            this.partTypesLoaded = true;
            var that = this;

            var target = $(this);
            target.empty();

            search.part_types(model_id, year, {
                success: function(part_types)
                {
                    target.html(part_types_template({part_types: part_types}));

                    if(part_types.length)
                    {

                        target.trigger("change");
                    }

                    that.loading = false;
                },
                error: function() { that.loading = false; }
            });
        }
    });

    // Add a vehicle
    $search.on('click', '.vehicle-add-submit > .submit', function(e)
    {
        var add_row = $(this).closest('.vehicle-add');

        var make_id  = $('#make').val();
        var model_id = $('#model').val();
        var year     = $('#year').val();

        cart.add_vehicle(make_id, model_id, year, {
            messages: get_messages(add_row),
            success: function(data) {
                location.reload();
            }
        });


    });

    // Remove a vehicle
    $search.delegate('.vehicle .identification > .remove', 'click', function(e)
    {
        e.preventDefault();

        var vehicle_row = $(this).closest('.vehicle');
        var vehicle_id  = vehicle_row.data('vehicle_id');

        cart.delete_vehicle(vehicle_id, {
            messages: get_messages(vehicle_row),
            success: function() {
                vehicle_row.fadeOut('fast', function() {
                    $(this).remove();
                    $cart.trigger('cart-update');
                    if($(".vehicle").length == 0)
                    {
                        $('.vehicle-add').show();
                    }
                });
            }
        });
    });

    $search.on('click', '.quick-add-part', function(e) {
        e.preventDefault();

        var add_row        = $(this).closest('.part-add');
        var vehicle_id     = $(this).closest('.vehicle').data('vehicle_id');
        var part_type_code = $(this).data('part_type_code');

        $categories_container.slideUp("fast", toggle_categories_glyphicon());

        cart.add_item(vehicle_id, part_type_code, {
            messages: get_messages(add_row),
            success: function(data) {
                var part_row = $(data);

                $('.vehicle[data-vehicle_id='+vehicle_id+']')
                    .find('.parts')
                    .append(part_row);

                if(part_row.data('application_id'))
                {
                    part_row.trigger('select-stock');
                }
                else
                {
                    part_row.trigger('select-application');
                }

                $('html, body').animate({
                    scrollTop: part_row.offset().top
                }, 1000);
            }
        });
    });

    // Add a part to a vehicle
    $search.on('click', '.part-add #part-add-submit', function(e)
    {
        e.preventDefault();

        var add_row        = $(this).closest('.part-add');
        var selection      = add_row.find('.selection');
        var vehicle_id     = $(this).closest('.vehicle').data('vehicle_id');
        var part_type_code = add_row.find('.part-types').val();

        $categories_container.hide();

        cart.add_item(vehicle_id, part_type_code, {
            messages: get_messages(add_row),
            success: function (data) {
                append_item_to_search(vehicle_id, $(data));
            }
        });
    });

    /**
     * Triggered when the user clicks on the "Add to search" button after selecting related parts
     * Adds each checked part type to the current cart search and closes the modal window
     */
    $(document).on('click', '#add-related-search', function(e) {
        e.preventDefault();

        var add_row        = $(this).closest('.part-add');
        var $checked_parts = $('#related-parts-info').find('input:checkbox:checked');
        var vehicle_id     = $('.vehicle').first().data('vehicle_id');

        $.each($checked_parts, function(i, checked_part) {
            cart.add_item(vehicle_id, checked_part.value, {
                messages: get_messages(add_row),
                success: function (data) {
                    append_item_to_search(vehicle_id, $(data));
                }
            });
        });
    });

    // Remove a part
    $search.on('click', '.remove-part', function(e)
    {
        e.preventDefault();

        var row = $(this).closest('.part');

        var item_id = row.data('item_id');

        cart.delete_item(item_id, {
            messages: get_messages(row),
            success: function() {
                row.fadeOut('fast', function() {
                    $(this).remove();
                });
            }
        });
    });

    $completed_items.delegate('.part .remove', 'click', function(e)
    {
        e.preventDefault();

        var row        = $(this).closest('.part');
        var item_id    = row.data('item_id');
        var vehicle_id = row.data('vehicle_id');

        var parts = $('.vehicle[data-vehicle_id='+vehicle_id+']').find('.parts');

        var stock_id = $(this).data('stock_id');

        cart.select_stock(item_id, null, {
            messages: get_messages(row),
            success: function(data) {
                var new_row = $(data);

                row.hide('fast', function() { $(this).remove(); });
                parts.append(new_row);
            }
        });
    });

    $search.on('click', '.select-application', function(e) {
        e.preventDefault();
        $(this).closest('.part').trigger('select-application');
    });

    $search.on('click', '.select-stock', function(e) {
        e.preventDefault();
        $(this).closest('.part').trigger('select-stock');
    });

    $search.on('click', '.select-stock-aft', function(e) {
        e.preventDefault();
        $(this).closest('.part').trigger('select-aftermarket-stock');
    });

    // Select an application for a part
    $search.on('click', '.application', function(e) {
        e.preventDefault();

        var row       = $(this).closest('.part');
        var item_id   = row.data('item_id');
        var selection = row.find('.selection');
        // increase click count

        var application_id = $(this).data('application_id');
		
        cart.select_application(item_id, application_id, {
            messages: get_messages(row),
            success: function(data) {
                var new_row = $(data);

                selection.hide('fast', function() {
                    row.before(new_row).remove();
                    new_row.trigger('select-stock');
                });
            }
        });
    });

    //Select an application for a part
    $search.on('click', '.add-to-cart', function(e) {
        e.preventDefault();

        var row = $(this).closest('.part');
        var item_id = row.data('item_id');
        var selection = row.find('.selection');

        var completed_items = $('#completed-items tbody');
        var stock_id = $(this).data('stock_id');

        cart.select_stock(item_id, stock_id, {
            messages: get_messages(row),
            success: function(data) {
                var new_row = $(data);
                selection
                    .hide('fast', function() {
                        if (!new_row.data('stock_id')) {
                            row.remove();
                            completed_items.append(new_row);
                        } else {
                            row.hide('fast', function() { $(this).remove(); });
                            completed_items.append(new_row);
                        }
                    });

                $add_confirmation_modal.find(".modal-body").load(document.base_url+'cart/add_confirmation/'+item_id, function() {
                    $add_confirmation_modal.modal('show');
                });

                $cart.trigger('cart-update');
            }
        });
    });

    $search.on('click', '.create-and-add', function (e) {
        e.preventDefault();

        var row = $(this).closest('.part');
        var item_id = row.data('item_id');
        var application_id = $(this).data('application_id');
        var completed_items = $('#completed-items', 'tbody');
        var selection = row.find('.selection-aft');

        cart.select_application(item_id, application_id, {
            messages: get_messages(row),
            success: function(data) {
                console.log(data);
                var new_row = $(data);
                selection.hide('fast', function() {
                    if (!new_row.data('stock_id')) {
                        row.remove();
                        completed_items.append(new_row);
                    } else {
                        row.hide('fast', function() { $(this).remove(); });
                        completed_items.append(new_row);
                    }
                });

                $add_confirmation_modal.find(".modal-body").load(document.base_url+'cart/add_confirmation/'+item_id, function() {
                    $add_confirmation_modal.modal('show');
                });

                $cart.trigger('cart-update');
            }
        });
    });

    // Begin an application selection for a part
    $search.on('select-application', '.part', function() {
        var expand      = $(this).find('.expand');
        var vehicle_row    = $(this).closest('.vehicle');

        var part_type_code = $(this).data('part_type_code');
        var model_id       = vehicle_row.data('model_id');
        var year           = vehicle_row.data('year');

        if(expand.data('content_state') == 'application')
        {
            expand
                .data('content_state', '')
                .hide('fast');

            return;
        }

        expand.data('content_state', 'application');

        search.applications(part_type_code, model_id, year, standard_display(expand, function(applications)
        {
            expand.find('.selection').html(applications_templates({applications: applications}));
        }));
    });

    // Begin a stock selection for a part
    $search.on('select-stock', '.part', function() {
        var expand      = $(this).find('.expand');
        var application_id = $(this).data('application_id');

        if(expand.data('content_state') == 'stock')
        {
            expand
                .data('content_state', '')
                .hide('fast');

            return;
        }

        expand.data('content_state', 'stock');

        search.stocks(application_id, standard_display(expand, function(data)
        {
            var has_additional_stocks = data.stocks_count > 0;
            expand.find('.selection').html(stocks_template({
                stocks: data.stocks,
                best_grade: data.best_grade,
                worst_grade: data.worst_grade,
                highest_year: data.highest_year,
                lowest_year: data.lowest_year,
                lowest_price: data.lowest_price,
                stocks_count: data.stocks_count,
                has_additional_stocks: has_additional_stocks,
                partial_stocks: true,
                application_id: application_id,
                discount: data.discount
            }));
            if (data.stocks.length === 0 && has_additional_stocks) {
                expand.find('.all-stocks').trigger('click');
            }
            apply_filters();
        }));
    });

    $search.on('select-aftermarket-stock', '.part', function () {
        var vehicle_row    = $(this).closest('.vehicle');
        var part_type_code = $(this).data('part_type_code');
        var model_id       = vehicle_row.data('model_id');
        var year           = vehicle_row.data('year');

        var expand  = $(this).find('.expand-aft');
        if(expand.data('content_state') === 'stock') {
            expand.data('content_state', '').hide('fast');
            return;
        }

        expand.data('content_state', 'stock');
        search.stocks_aftermarket(model_id, year, part_type_code, standard_display(expand, function(data) {
            expand.find('.selection-aft').html(stocks_template_aft({stocks: data.stocks, stockNames: data.stockNames}));
        }));
    });

    $search.on('click', '.all-stocks', function(e) {
        e.preventDefault();

        var application_id = $(this).data('application_id');
        var tr_show = $(this).closest('tr');
        var tr_hide = tr_show.next();

        search.all_stocks(application_id, {
            success: function(data)
            {
                var template = $(stocks_template({
                    stocks: data.stocks,
                    partial_stocks: false,
                    application_id: application_id,
                    discount: data.discount
                }));
                tr_show.before(template.find('tbody tr')).hide();
                tr_hide.show();
                apply_filters();
            }
        });
    });

    $search.on('click', '.view_photos', function(e) {
        e.preventDefault();

        stock.get_all_photos(
            $(this).data('stock_number'),
            $(this).data('file_number'),
            $(this).data('recycler_code'),
            { success: display_photos }
        );
    });

    function display_photos(data) {
        var items = [];

        for (var i = 0; i < data.length; i++) {
            items.push({
                src: data[i],
                h: 0,
                w: 0
            });
        }

        if (items.length <= 0) {
            return;
        }

        var gallery = new PhotoSwipe( document.querySelector('#photos-modal'), PhotoSwipeUI_Default, items);
        gallery.listen('gettingData', function(index, item) {
            if (item.html === undefined && item.onloading === undefined && (item.w < 1 || item.h < 1)) {
                var img = new Image();
                img.onload = function() {
                    item.w = this.naturalWidth;
                    item.h = this.naturalHeight;
                    gallery.invalidateCurrItems();
                    gallery.updateSize(true);
                };
                img.src = item.src; // let's download image
            }
        });

        gallery.init();
    }

    $notes_modal.on('show.bs.modal', function(e) {
        var item_row = $(e.relatedTarget).closest('.part');
        var item_id = item_row.data('item_id');

        $(this).find('#save-note').data('item_id', item_id);

        cart.get_item(item_id, {
            success: function(data) {
                $notes_modal.find('#item-notes-input').val(data.note);
            }
        });
    });

    $notes_modal.on('click', '#save-note', function() {
        var item_id = $(this).data('item_id');
        var note = $notes_modal.find('#item-notes-input').val();

        if (!item_id) {
            return false;
        }

        cart.set_item_note(item_id, note);
    });

    $notes_modal.on('shown.bs.modal', function () {
        $notes_modal.find('#item-notes-input').focus();
    });

    $search.on('click', '#toggle-categories', function() {
        $categories_container.slideToggle("fast", toggle_categories_glyphicon());
    });


    $('.part-types').select2({theme:"bootstrap"});
    $('#filter-year, #filter-quality').select2({
        minimumResultsForSearch: Infinity,
        theme: "bootstrap"
    });

    if ($search.find('.part').length === 0) {
        $categories_container.show("fast", toggle_categories_glyphicon());
    }

    function toggle_categories_glyphicon()
    {
        var $glyphicon_container = $('#toggle-categories').find('.menu-glyphicon');

        if ($categories_container.is(':visible')) {
            $glyphicon_container.removeClass('glyphicon-menu-up').addClass('glyphicon-menu-down');
        } else {
            $glyphicon_container.removeClass('glyphicon-menu-down').addClass('glyphicon-menu-up');
        }
    }

    $search.on('change', '.search-filter', function() {
        apply_filters();
    });

    function apply_filters()
    {
        var filter_grades = $quality_filter.val();
        var filter_year = $year_filter.val() === "1";
        var current_vehicle_year = $vehicles.length > 0
            ? $vehicles.filter(":first").data('year')
            : "";

        $('.stock-row').each(function() {
            var stock_row = $(this);
            var must_display = grade_filtering(stock_row.data('grade'), filter_grades)
                && year_filtering(stock_row.data('year'), current_vehicle_year, filter_year);

            must_display ? $(this).show() : $(this).hide();
        });
    }

    function grade_filtering(grade, filter_grades)
    {
        return !(filter_grades.length > 0 && filter_grades.indexOf(grade) === -1);
    }

    function year_filtering(year, vehicle_year, must_filter)
    {
        if (!must_filter) {
            return true;
        }

        return year >= vehicle_year;
    }

    /**
     * Append the part type application select block to the current search and scroll
     * down to it
     *
     * @param {int} vehicle_id
     * @param {Object} part_row
     */
    function append_item_to_search(vehicle_id, part_row)
    {
        $('.vehicle[data-vehicle_id='+vehicle_id+']')
            .find('.parts')
            .append(part_row);

        if(part_row.data('application_id')) {
            part_row.trigger('select-stock');
        }
        else {
            part_row.trigger('select-application');
        }

        $('html, body').animate({
            scrollTop: part_row.offset().top
        }, 1000);
    }

    $search.on('click', '.stock-show-more', function() {
        var glyphicon_container = $(this).find('.glyphicon');
        var stock_row = $(this).closest('tr');
        var show_more_row = stock_row.next('tr');

        show_more_row.slideToggle("fast");
        glyphicon_container.toggleClass('glyphicon-plus').toggleClass('glyphicon-minus');
    });
});